import { useCallback } from "react"
import { useProcessoApi } from "../../../infra/geo-veles"
import { useAppSelector } from "../../../presentation/hooks/store-hooks"
import { useExtracoesService } from "../extracoes"
import { useUIService } from "../../ui"

export const useProcessoService = () => {
    // State
    const { currentUser } = useAppSelector((state) => state.user)
    // Service
    const { getExtracoes } = useExtracoesService()
    const { setAlert } = useUIService()
    // Infra
    const { createReprocessoApi, findProcessoByIdVelesGeoExtracaoApi, findProcessoByIdVelesGeoProcessoApi } = useProcessoApi()

    const createReprocesso = useCallback(async (IdVelesGeoExtracao: number) => {
        if (currentUser) {
            try {
                await createReprocessoApi({ IdVelesGeoExtracao })
                await getExtracoes()
            } catch (error: any) {
                setAlert({
                    message: error.response.data.error,
                    type: 'error'
                })
            }
        }
    }, [createReprocessoApi, currentUser, getExtracoes, setAlert])

    const findProcessoByIdVelesGeoExtracao = useCallback(async (IdVelesGeoExtracao: number) => {
        if (currentUser) {
            try {
                const findLastProcesso = await findProcessoByIdVelesGeoExtracaoApi({ IdVelesGeoExtracao })

                return findLastProcesso
            } catch (error: any) {
                setAlert({
                    message: error.response.data.error,
                    type: 'error'
                })
            }
        }
    }, [currentUser, findProcessoByIdVelesGeoExtracaoApi, setAlert])

    const findProcessoByIdVelesGeoProcesso = useCallback(async (IdVelesGeoProcesso: number) => {
        if (currentUser) {
            try {
                const processo = await findProcessoByIdVelesGeoProcessoApi({ IdVelesGeoProcesso })

                return processo
            } catch (error: any) {
                setAlert({
                    message: error.response.data.error,
                    type: 'error'
                })
            }
        }
    }, [currentUser, findProcessoByIdVelesGeoProcessoApi, setAlert])

    return {
        createReprocesso,
        findProcessoByIdVelesGeoExtracao,
        findProcessoByIdVelesGeoProcesso
    }
}